<section class="mat-typography">
  <form
    [formGroup]="formModel.formGroup"
    fxLayout="column"
    fxLayoutAlign="center stretch"
  >
    <mat-form-field fxFlex="100">
      <mat-label>Message</mat-label>
      <textarea rows="5" formControlName="message" matInput></textarea>
      <mat-error *ngFor="let validator of formModel.validators.message">
        <span
          *ngIf="formModel.formGroup.controls.message.hasError(validator.type)"
        >
          {{ validator.message }}
        </span>
      </mat-error>
    </mat-form-field>
    <button
      fxFlex="100"
      mat-raised-button
      color="primary"
      [class.spinner]="sending"
      [disabled]="sending"
      (click)="send()"
    >
      <mat-icon>send</mat-icon>
      Send
    </button>
  </form>
</section>
